<div class="timeline-component">
  @if (isHorizontal()) {
    <drag-scroll
      class="timeline-component__scroll"
      [drag-scroll-y-disabled]="true"
      #dragScrollComponent
    >
      <ng-container [ngTemplateOutlet]="timeline"></ng-container>
    </drag-scroll>
  } @else {
    <ul class="timeline" [ngClass]="{ 'timeline-horizontal': isHorizontal() }">
      @for (deployment of sortedDeployments; track deployment) {
        <li class="timeline-item" [ngClass]="{ current: isCurrent(deployment) }">
          <div class="timeline-badge"></div>
          <div class="timeline-panel">
            <h4 class="timeline-panel-title">
              {{
                type() === 'collar'
                  ? deployment.animalName
                  : 'Collar: ' + deployment.collarId?.toString()
              }}
            </h4>
            <vectronic-details-item header="Start Date" [isSmall]="true" [isInLine]="true">
              <ng-container>
                {{ deployment.startDate | date: 'dd MMM yyyy' : 'UTC' }}
              </ng-container>
            </vectronic-details-item>
            <vectronic-details-item header="End Date" [isSmall]="true" [isInLine]="true">
              <ng-container>
                {{ deployment.endDate | date: 'dd MMM yyyy' : 'UTC' }}
              </ng-container>
            </vectronic-details-item>
            <vectronic-details-item header="Comment" [isSmall]="true" [isInLine]="true">
              <ng-container>
                {{
                  deployment?.comment !== null
                    ? deployment?.comment?.length > 30
                      ? (deployment?.comment | slice: 0 : 30) + '...'
                      : deployment?.comment
                    : ''
                }}
              </ng-container>
            </vectronic-details-item>
            <div class="timeline-panel-buttons">
              @if (isHorizontal() && hasEdit() && canEdit(deployment)) {
                <button
                  mat-button
                  (click)="selectDeployment.emit({ deployment: deployment, cause: 'delete' })"
                  [matTooltip]="'Delete deployment'"
                >
                  <mat-icon color="warn">delete</mat-icon>
                  Delete
                </button>

                <button
                  mat-button
                  (click)="selectDeployment.emit({ deployment: deployment, cause: 'edit' })"
                  matTooltip="Edit deployment"
                >
                  <mat-icon>create</mat-icon>
                  Edit
                </button>
              }
              @if (isHorizontal() && hasView()) {
                <button
                  mat-button
                  (click)="onLinkToDeployment(deployment)"
                  [matTooltip]="type() === 'animal' ? 'View collar' : 'View animal'"
                >
                  <mat-icon mat-button color="accent">visibility</mat-icon>
                  {{ type() === 'animal' ? 'Collar' : 'Animal' }}
                </button>
              }
              @if (!isHorizontal() && hasEdit() && canEdit(deployment)) {
                <button
                  mat-button
                  (click)="selectDeployment.emit({ deployment: deployment, cause: 'delete' })"
                  [matTooltip]="'Delete deployment'"
                >
                  <mat-icon color="warn">delete</mat-icon>
                  Delete
                </button>

                <button
                  mat-icon-button
                  (click)="selectDeployment.emit({ deployment: deployment, cause: 'edit' })"
                  matTooltip="Edit deployment"
                >
                  <mat-icon>create</mat-icon>
                </button>
              }
              @if (!isHorizontal() && hasView()) {
                <button
                  mat-icon-button
                  (click)="onLinkToDeployment(deployment)"
                  [matTooltip]="type() === 'animal' ? 'View collar' : 'View animal'"
                >
                  <mat-icon>visibility</mat-icon>
                </button>
              }
            </div>
          </div>
        </li>
      }
    </ul>
  }
  <ng-template #timeline>
    <ul class="timeline" [ngClass]="{ 'timeline-horizontal': isHorizontal() }">
      @for (deployment of sortedDeployments; track deployment) {
        <li class="timeline-item" [ngClass]="{ current: isCurrent(deployment) }">
          <div class="timeline-badge"></div>
          <div class="timeline-panel">
            <h4 class="timeline-panel-title">
              {{
                type() === 'collar'
                  ? deployment.animalName
                  : 'Collar: ' + deployment.collarId?.toString()
              }}
            </h4>
            <vectronic-details-item header="Start Date" [isSmall]="true" [isInLine]="true">
              <ng-container>
                {{ deployment.startDate | date: 'dd MMM yyyy' : 'UTC' }}
              </ng-container>
            </vectronic-details-item>
            <vectronic-details-item header="End Date" [isSmall]="true" [isInLine]="true">
              <ng-container>
                {{ deployment.endDate | date: 'dd MMM yyyy' : 'UTC' }}
              </ng-container>
            </vectronic-details-item>
            <vectronic-details-item header="Comment" [isSmall]="true" [isInLine]="true">
              <ng-container>
                {{
                  deployment?.comment !== null
                    ? deployment?.comment?.length > 30
                      ? (deployment?.comment | slice: 0 : 30) + '...'
                      : deployment?.comment
                    : ''
                }}
              </ng-container>
            </vectronic-details-item>
            <div class="timeline-panel-buttons">
              @if (isHorizontal() && hasEdit() && canEdit(deployment)) {
                <button
                  mat-button
                  (click)="selectDeployment.emit({ deployment: deployment, cause: 'delete' })"
                  [matTooltip]="'Delete deployment'"
                >
                  <mat-icon color="warn">delete</mat-icon>
                  Delete
                </button>

                <button
                  mat-button
                  (click)="selectDeployment.emit({ deployment: deployment, cause: 'edit' })"
                  matTooltip="Edit deployment"
                >
                  <mat-icon color="accent">create</mat-icon>
                  Edit
                </button>
              }
              @if (isHorizontal() && hasView()) {
                <button
                  mat-button
                  (click)="onLinkToDeployment(deployment)"
                  [matTooltip]="type() === 'animal' ? 'View collar' : 'View animal'"
                >
                  <mat-icon color="accent">visibility</mat-icon>
                  {{ type() === 'animal' ? 'Collar' : 'Animal' }}
                </button>
              }
              @if (!isHorizontal() && hasEdit() && canEdit(deployment)) {
                <button
                  mat-button
                  (click)="selectDeployment.emit({ deployment: deployment, cause: 'delete' })"
                  [matTooltip]="'Delete deployment'"
                >
                  <mat-icon color="warn">delete</mat-icon>
                  Delete
                </button>

                <button
                  mat-icon-button
                  (click)="selectDeployment.emit({ deployment: deployment, cause: 'edit' })"
                  matTooltip="Edit deployment"
                >
                  <mat-icon color="accent">create</mat-icon>
                </button>
              }
              @if (!isHorizontal() && hasView()) {
                <button
                  mat-icon-button
                  (click)="onLinkToDeployment(deployment)"
                  [matTooltip]="type() === 'animal' ? 'View collar' : 'View animal'"
                >
                  <mat-icon color="accent">visibility</mat-icon>
                </button>
              }
            </div>
          </div>
        </li>
      }
    </ul>
  </ng-template>
</div>
